<div style="width: 800px; height: 650px;" class="ui-dark-background" data-cy="case-procedure-add-form">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="case-procedure-add-form-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="case-procedure-add-form-header">
      <div class="section-header-title" data-cy="case-procedure-add-form-title">
        Add Form
      </div>
      <div style="flex: 1; text-align: right; position: relative; top: -2px; font-weight: normal;" data-cy="case-procedure-add-form-review-container">
        <mat-checkbox style="margin-right: 5px;" [checked]="isShowInReview" (change)="onIsShowInReviewChange($event)" data-cy="case-procedure-add-form-review-checkbox">View forms in review</mat-checkbox>
      </div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;" data-cy="case-procedure-add-form-content">
      @if (isLoading) {
        <app-tdo-progress-spinner style="height: 100%;" data-cy="case-procedure-add-form-spinner"></app-tdo-progress-spinner>
      }
      @if (!isLoading) {
        <div style="flex: 1; overflow-y: hidden;" data-cy="case-procedure-add-form-tabs-container">
          <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedIndexChange)="onSelectedIndexChange($event)" style="height: 100%; overflow-y: hidden;" data-cy="case-procedure-add-form-tab-group">
            @if (this.selectionSection === 1) {
              <mat-tab [label]="this.caseProcedureName" style="height: 100%;" data-cy="case-procedure-add-form-procedure-tab">
                <div style="flex: 1; overflow-y: hidden; height: 480px; margin-top: 2px;" data-cy="case-procedure-add-form-procedure-table-container">
                  <tdo-table #procedureTable [dataSource]="dFormsProcedure"
                    [isMultiSelection]="false" [isSearchable]="true" [pageSize]="200"
                    [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)"
                    data-cy="case-procedure-add-form-procedure-table">
                    <tdo-table-column displayName="Form" propertyName="DFormName" isSortable="true" [rowTemplate]="formName" data-cy="case-procedure-add-form-procedure-column">
                      <ng-template #formName let-row>
                        @if (row.model.DFormName) {
                          <div data-cy="case-procedure-add-form-procedure-form-name">
                            {{ row.model.DFormName }}
                            @if (row.model.cfgDFormVersionRevision) {
                              <span>(V{{ row.model.cfgDFormVersionRevision }})</span>
                            }
                          </div>
                        }
                      </ng-template>
                    </tdo-table-column>
                  </tdo-table>
                </div>
              </mat-tab>
            }
            <mat-tab [label]="this.formsTabRightLabel" data-cy="case-procedure-add-form-all-tab">
              <div style="flex: 1; overflow-y: auto; height: 480px; margin-top: 2px;" data-cy="case-procedure-add-form-all-table-container">
                <tdo-table #allTable [dataSource]="dFormsAll"
                  [isMultiSelection]="false" [isSearchable]="true" [isUsePaginator]="true"
                  [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)"
                  data-cy="case-procedure-add-form-all-table">
                  <tdo-table-column displayName="Form" propertyName="DFormName" isSortable="true" [rowTemplate]="formName2" data-cy="case-procedure-add-form-all-column">
                    <ng-template #formName2 let-row>
                      @if (row.model.DFormName) {
                        <div data-cy="case-procedure-add-form-all-form-name">
                          {{ row.model.DFormName }}
                          @if (row.model.cfgDFormVersionRevision) {
                            <span>(V{{ row.model.cfgDFormVersionRevision }})</span>
                          }
                        </div>
                      }
                    </ng-template>
                  </tdo-table-column>
                </tdo-table>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      }
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="case-procedure-add-form-footer">
      <div style="flex: 1; margin-right: 6px; display: flex;" data-cy="case-procedure-add-form-teeth-container">
        @if (caseWorkItem && (caseWorkItem.dataPatientCaseItemTeeth && caseWorkItem.dataPatientCaseItemTeeth.length > 0)) {
          <div style="display: flex; margin-top: 6px;" data-cy="case-procedure-add-form-teeth-selection">
            <div style="margin-left: 10px; margin-right: 6px;" data-cy="case-procedure-add-form-teeth-label">For tooth / teeth:</div>
            @for (cb of caseWorkItem.dataPatientCaseItemTeeth; track cb) {
              <mat-checkbox (change)="onSelectedTeethChange($event, cb)" [checked]="isChecked(cb)" style="margin-right: 10px;" data-cy="case-procedure-add-form-teeth-checkbox">{{cb.Notation}}</mat-checkbox>
            }
          </div>
        }
      </div>
      <button (click)="close(true)" class="tdo-button tdo-close" style="margin-right: 10px;" data-cy="case-procedure-add-form-cancel-btn">Cancel</button>
      <button (click)="addForms()" [disabled]="dFormsSelected.length<1" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="case-procedure-add-form-add-btn">Add</button>
    </div>
  </div>
</div>

